import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Trans } from 'react-i18next';

import {
    BB_BETFEED_FILTER_BOX_CSS_CLASS_BLOCK_NAME,
    BB_BETFEED_FILTER_BOX_CELL_CSS_CLASS_BLOCK_NAME,
    BB_BETFEED_FILTER_BOX_SELECTED_CSS_CLASS_NAME_IDENTIFIER,
    BB_BETFEED_FILTER_TYPE_SPORTS,
    BB_BETFEED_FILTER_CSS_CLASS_BODY_FILTER_NAME,
    BB_BETFEED_SPORT_FILTERS_TITLE_TEXT,
    BB_BETFEED_CLEAR_FILTERS_TEXT,
    BB_BETFEED_FILTER_BOX_CLEAR_FILTER_CSS_CLASS_BLOCK_NAME,
    BB_BETFEED_FILTER_BOX_CLEAR_FILTER_ICON_CSS_CLASS_BLOCK_NAME,
    BB_BETFEED_FILTER_BOX_CLEAR_FILTER_DISABLED_CSS_CLASS_NAME,
    GTM_BETFEED_SPORTS_FILTER,
    GTM_BETFEED_CLEAR_FILTERS,
    BB_BETFEED_FILTER_BOX_SPORTS_CONTAINER_CLASS_NAME,
    BB_BETFEED_FILTER_BOX_SPORT_ITEM_CLASS_NAME,
    BB_BETFEED_FILTER_BOX_SPORT_COLUMNS_AMOUNT,
    BB_BETFEED_FILTER_BOX_SPORT_ITEM_HEIGHT,
} from '../../constants';

export class SportFilter extends React.Component {

    constructor(props) {
        super(props);
        this.clearFiltersHandler = this.clearFiltersHandler.bind(this);
        this.handleToggleFilter = this.handleToggleFilter.bind(this);
    }

    static propTypes = {
        sportFilter: PropTypes.object.isRequired,
        fillBlankCell: PropTypes.func.isRequired,
        selected: PropTypes.object.isRequired,
        toggleFilter: PropTypes.func.isRequired,
        clearFiltersHandler: PropTypes.func.isRequired,
        gtmAttribute: PropTypes.string,
    }

    static defaultProps = {
        gtmAttribute: null,
    }

    clearFiltersHandler () {
        if (Object.keys(this.props.selected).length) {
            this.props.clearFiltersHandler(BB_BETFEED_FILTER_TYPE_SPORTS.id);
        }
    }

    clearFilter() {
        const clearFilterClassName = classNames(
            BB_BETFEED_FILTER_BOX_CSS_CLASS_BLOCK_NAME,
            BB_BETFEED_FILTER_BOX_CLEAR_FILTER_CSS_CLASS_BLOCK_NAME,
            { [BB_BETFEED_FILTER_BOX_CLEAR_FILTER_DISABLED_CSS_CLASS_NAME]: !Object.keys(this.props.selected).length },
        );

        return <div key={'clear-filter'} className={clearFilterClassName} onClick={this.clearFiltersHandler} data-spectate-product={`${this.props.gtmAttribute};${GTM_BETFEED_SPORTS_FILTER};${GTM_BETFEED_CLEAR_FILTERS}`}>
            <div className={BB_BETFEED_FILTER_BOX_CELL_CSS_CLASS_BLOCK_NAME}>
                <span className={BB_BETFEED_FILTER_BOX_CLEAR_FILTER_ICON_CSS_CLASS_BLOCK_NAME}></span>
                <Trans>{BB_BETFEED_CLEAR_FILTERS_TEXT}</Trans>
            </div>
        </div>;
    }

    handleToggleFilter(filter, id) {
        return () => {
            this.props.toggleFilter(filter, id);
        };
    }

    renderSports() {
        const sportFilter = this.props.sportFilter;
        const sportsList = Object.keys(sportFilter);
        // dynamic height needed otherwhise it will add columns, instead keeping 2.
        // thanks to flex-direction: column.
        const containerHeight = Math.round(
            sportsList.length / BB_BETFEED_FILTER_BOX_SPORT_COLUMNS_AMOUNT
        ) * BB_BETFEED_FILTER_BOX_SPORT_ITEM_HEIGHT;

        return (
            <div
                className={BB_BETFEED_FILTER_BOX_SPORTS_CONTAINER_CLASS_NAME}
                style={{
                    height: `${containerHeight}px`,
                }}
            >
                {sportsList.map(sportSlug => {
                    const filter = sportFilter[sportSlug];
                    const className = `${BB_BETFEED_FILTER_BOX_SPORT_ITEM_CLASS_NAME}
                        ${BB_BETFEED_FILTER_BOX_CSS_CLASS_BLOCK_NAME}${this.props.selected[sportSlug] ?
                        ` ${BB_BETFEED_FILTER_BOX_SELECTED_CSS_CLASS_NAME_IDENTIFIER}` : ''}`;

                    return <div key={sportSlug} data-sport-slug={sportSlug} className={className} onClick={this.handleToggleFilter(BB_BETFEED_FILTER_TYPE_SPORTS.id, sportSlug)} data-spectate-product={`${this.props.gtmAttribute};${GTM_BETFEED_SPORTS_FILTER};${sportSlug}`}>
                        <div className={BB_BETFEED_FILTER_BOX_CELL_CSS_CLASS_BLOCK_NAME}>{filter.name}</div>
                    </div>;
                })}
            </div>
        );
    }

    render() {
        const filterTitle = (
            <div key={'sports-title'} className={BB_BETFEED_FILTER_CSS_CLASS_BODY_FILTER_NAME}>
                <Trans>{BB_BETFEED_SPORT_FILTERS_TITLE_TEXT}</Trans>
            </div>
        );

        return (
            <>
                {this.clearFilter()}
                {filterTitle}
                {this.renderSports()}
            </>
        );
    }
}

export default SportFilter;
